export enum ETopMenuStatus {
  Offline = 'offline',
  Default = 'default',
  ChangeList = 'changeList',
  NotAuthorized = 'notAuthorized',
  Loading = 'loading',
}
